import React, { useEffect, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import Button from 'react-bootstrap/Button';
import '../../assets/style/Modal.css';
import KYCDocumentGallery from '../../components/KYCDocumentGallery';
import BasicDetails from '../../components/BasicDetails';
import ModalHeader from '../../components/ModalHeader';
import {
  CLICK_ACTIONS,
  IIB_STATUS,
  KYC_DOCUMENT_STATUS,
  REGISTRATION_STATUS,
} from '../../utils/Constant';
import {
  candidateSelector,
  getCandidateDetails,
} from '../../features/assignGridSlice';
import { DocumentType, LoggedUserType, UserType } from '../../utils/Types';
import CenterSpinner from '../../components/CenterSpinner';
import {
  updateKYCDocument,
  updateKYCDocumentStatusSelector,
} from '../../features/onboardingSlice';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import { UpdateKYCDocumentStatusType } from '../../utils/OnboardingTypes';
import { useLoader } from '../../loader/LoaderProvider';
import { onStatusUpdate } from '../onboarding/OnboardingPageHelper';
import { loginSelector } from '../../features/loginSlice';

interface IKYCVerificationModelProps {
  isOpen: boolean;
  candidateId?: number;
  toggleKYCVerificationModel: (action: string) => void;
  refreshData?: () => void;
}

const KYCVerificationModel: React.FunctionComponent<
  IKYCVerificationModelProps
> = ({
  isOpen,
  candidateId,
  toggleKYCVerificationModel,
  refreshData = () => {},
}: IKYCVerificationModelProps) => {
  const [user, setUser] = useState<UserType>();
  const { showLoader, setShowLoader } = useLoader();
  const dispatch = useAppDispatch();
  const userDetails: any = useAppSelector(candidateSelector).user;
  const updateKYCDocumentStatus: UpdateKYCDocumentStatusType = useAppSelector(
    updateKYCDocumentStatusSelector
  );
  const loggedUser: LoggedUserType = useAppSelector(loginSelector).user;

  const documents: DocumentType[] = useAppSelector(candidateSelector).documents;
  /**
   * This method call API to update the document status.
   * @param actionType Approve/Reject
   * @param documentId
   */
  const approveRejectDocument = (
    approvalStatusType: number,
    iibApprovalStatusType: number,
    documentId: number | undefined,
    comment: string
  ) => {
    setShowLoader(true);
    // Set approval status and IIB approval status, but send null if not provided
    const approvalStatus =
      approvalStatusType === null
        ? null
        : approvalStatusType === KYC_DOCUMENT_STATUS.APPROVED
          ? 0
          : 1;
    const iibApprovalStatus =
      iibApprovalStatusType === null
        ? null
        : iibApprovalStatusType === IIB_STATUS.APPROVED
          ? 2
          : iibApprovalStatusType === IIB_STATUS.REJECT
            ? 3
            : iibApprovalStatusType === IIB_STATUS.HOLD
              ? 4
              : null;

    // Dispatch the update action
    dispatch(
      updateKYCDocument({
        candidateId: user?.candidateid,
        documentId: documentId,
        approvalStatus: approvalStatus, // Send null if not set
        comments: comment,
        iibApprovalStatus: iibApprovalStatus, // Send null if not set
      })
    );
  };
  const getUserDetails = () => {
    if (candidateId) {
      setShowLoader(true);
      dispatch(getCandidateDetails(candidateId));
    }
  };
  useEffect(() => {
    onStatusUpdate(
      updateKYCDocumentStatus,
      user,
      setShowLoader,
      getUserDetails,
      dispatch
    );
  }, [updateKYCDocumentStatus]);
  useEffect(() => {
    if (candidateId === userDetails.candidateid) {
      setUser(userDetails);
      setShowLoader(false);
    } else if (!userDetails.candidateid) {
      setShowLoader(false);
    }
  }, [userDetails]);
  useEffect(() => {
    getUserDetails();
  }, [candidateId]);

  const toggle = () => {
    if (user?.userActivationStatus === REGISTRATION_STATUS.ACTIVE) {
      toggleKYCVerificationModel(CLICK_ACTIONS.NAVIGATE_TO_ASSIGN_GRID);
    } else {
      toggleKYCVerificationModel(CLICK_ACTIONS.NO_ACTION);
    }
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={toggleKYCVerificationModel}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="bg-white p-2 rounded border">
        <ModalHeader
          toggle={toggle}
          photoUrl={user?.photo ?? ''}
          docURLBack={undefined}
        />
        <BasicDetails
          user={user}
          isEditable={true}
          refreshData={refreshData}
          setShowLoader={setShowLoader}
        />
        <KYCDocumentGallery
          onApproveRejectAction={approveRejectDocument}
          documents={documents}
          candidateId={candidateId}
          roleId={loggedUser?.roleId}
        />
        <div className="d-flex justify-content-center mb-4 mt-2">
          <Button variant="primary" className="cl-btn-primary" onClick={toggle}>
            Close
          </Button>
        </div>
        <CenterSpinner showLoader={showLoader} />
      </div>
    </ModalComponent>
  );
};

export default KYCVerificationModel;
